<template>
  <div class="flex flex-col" :class="size">
    <slot name="label">
      <label :for="props.name" :class="props.classes">{{ label }}</label>
    </slot>
    <slot :value="value" :errorMessage="errorMessage">
      <InputText
        v-on:keydown.enter.prevent
        :name="props.name"
        :id="props.name"
        type="text"
        class="h-10"
        v-model="value"
        :disabled="props.disabled"
        :maxLength
      />
      <small v-if="errorMessage" :id="props.name + '-help'" class="text-danger-500">{{ errorMessage }}</small>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";

interface Props {
  name: string;
  value?: string;
  label: string;
  size?: string;
  classes?: string;
  disabled?: boolean;
  maxLength?: number;
}
const props = withDefaults(defineProps<Props>(), {
  size: "w-full",
  classes: "font-bold",
  disabled: false,
});

const { value, errorMessage } = useField<string>(() => props.name);
</script>
